import React from "react";

export default function IndexSectionFaq8() {
  return (
    <React.Fragment>
      <>
        <section
          className="relative py-20 md:py-32 overflow-hidden bg-gray-50"
          id="faq"
        >
          <img
            className="absolute top-0 left-0 mt-44"
            src="saturn-assets/images/faq/light-blue-left.png"
            alt
          />
          <img
            className="absolute top-0 right-0 mt-10"
            src="saturn-assets/images/faq/star-right.svg"
            alt
          />
          <div className="relative container px-4 mx-auto">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-24">
                <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 rounded-full">
                  FREQUENTLY ASK QUESTION
                </span>
                <h1 className="font-heading text-5xl xs:text-6xl md:text-7xl font-bold">
                  <span>よくあるご質問</span>
                </h1>
              </div>
              <div className="flex flex-wrap -mx-4 -mb-8">
                <div className="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
                  <div className="flex flex-col h-full max-w-xs mx-auto md:max-w-none px-6 py-9 md:pl-9 md:pr-12 bg-white rounded-3xl shadow-lg">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                      定額以外にかかる料金が知りたい
                    </h4>
                    <p className="text-gray-500 mb-4">
                      メール連携以外をご希望の場合は、初期費用（開発費用）として
                      15万円が別途かかります。
                    </p>
                  </div>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
                  <div className="flex flex-col h-full max-w-xs mx-auto md:max-w-none px-6 py-9 md:pl-9 md:pr-12 bg-white rounded-3xl shadow-lg">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                      スマートフォンの用意は？
                    </h4>
                    <p className="text-gray-500 mb-4">
                      弊社で用意することも、御社で余っているスマートフォンを用いることも可能です。
                    </p>
                  </div>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
                  <div className="flex flex-col h-full max-w-xs mx-auto md:max-w-none px-6 py-9 md:pl-9 md:pr-12 bg-white rounded-3xl shadow-lg">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                      スマートフォンの種類は？
                    </h4>
                    <p className="text-gray-500 mb-4">
                      iPhone でも Android
                      でも対応しております。らくらくQRシステムはWebアプリケーションです。
                    </p>
                  </div>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
                  <div className="flex flex-col h-full max-w-xs mx-auto md:max-w-none px-6 py-9 md:pl-9 md:pr-12 bg-white rounded-3xl shadow-lg">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                      どれぐらいのスペックが必要？
                    </h4>
                    <p className="text-gray-500 mb-4">
                      中古2万円程度で購入できるスマートフォンで十分です。インカメラとWebアプリを用いるためスペックは必要ございません。
                    </p>
                  </div>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
                  <div className="flex flex-col h-full max-w-xs mx-auto md:max-w-none px-6 py-9 md:pl-9 md:pr-12 bg-white rounded-3xl shadow-lg">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                      回線の契約は必要ですか？
                    </h4>
                    <p className="text-gray-500 mb-4">
                      WiFi
                      に接続できる環境であればモバイル回線の契約は不要でございます。
                    </p>
                  </div>
                </div>
                <div className="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8">
                  <div className="flex flex-col h-full max-w-xs mx-auto md:max-w-none px-6 py-9 md:pl-9 md:pr-12 bg-white rounded-3xl shadow-lg">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                      必要な準備はありますか？
                    </h4>
                    <p className="text-gray-500 mb-4">
                      私たちはWebサービスと提供するため御社でご用意いただくものはスマートフォンのみとなります。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
